import React from "react";

const AnalyticsIcon = ({
  width = "1em",
  height = "1em",
  stroke = "currentColor",
  className = ""
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M13.3333 5.83301H18.3333V10.833"
        stroke={stroke}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3334 5.83301L11.2501 12.9163L7.08341 8.74967L1.66675 14.1663"
        stroke={stroke}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AnalyticsIcon;
